import { useTranslation } from 'react-i18next';
import { useStarWallet } from '../../hooks/useStarWallet.js';
import { StarGlyph } from './StarGlyph.js';
import styles from './StarGauge.module.css';

export function gaugeColor(balance: number): 'blue' | 'green' | 'orange' | 'red' {
  if (balance > 150) return 'blue';
  if (balance >= 60) return 'green';
  if (balance >= 15) return 'orange';
  return 'red';
}

// Light tints: the gauge sits on the dark cosmic backdrop.
const FILL = { blue: '#6f9bff', green: '#5fd08a', orange: '#f59e4b', red: '#ef6b5b' };
const CEILING = 200;

/** `compact` drops the level bar (the number keeps its colour): the chat header needs the room for the title. */
export function StarGauge({ onTopUp, compact = false }: { onTopUp: () => void; compact?: boolean }): JSX.Element {
  const { t } = useTranslation('home');
  const { balance } = useStarWallet();
  const color = gaugeColor(balance);
  const pct = Math.min(100, Math.round((balance / CEILING) * 100));
  return (
    <button
      type="button"
      onClick={onTopUp}
      data-testid="star-gauge"
      className={styles.gauge}
      aria-label={t('chat.gaugeAria', { balance })}
    >
      <StarGlyph />
      <span className={styles.balance} style={{ color: FILL[color] }}>{balance}</span>
      {!compact && (
        <span className={styles.track}>
          <span className={styles.fill} style={{ width: `${pct}%`, background: FILL[color] }} />
        </span>
      )}
    </button>
  );
}
